import { html, nothing } from 'lit';
import componentStyles from './article-card.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class ArticleCard extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      /**
       * XS and LG images object.
       * @type {{src: string, altText: string}}
       */
      image: { type: Object },
      /**
       * Main content area title
       */
      title: { type: String },
      /**
       * Main content area text below title
       */
      articleLength: { type: String },
      /**
       * Button text
       */
      category: { type: Object },
      /**
       * Button url
       */
      url: { type: String },
    };
  }

  constructor() {
    super();
    this.category = {};
    this.articleLength = '';
  }

  render() {
    return html`
      <div class="article-card">
        <div class="article-card__wrapper">
          <a href="${this.url}">
            <div class="article-card__image">
              <hf-image
                src="${this.image.src}"
                alt="${this.image.alt}"
                imageSize="full"
              ></hf-image>
              ${this.category && this.category.text
                ? html`
                    <div class="article-card__category">
                      <hf-icon
                        name="${this.category.iconName}"
                        class="article-card__icon"
                      ></hf-icon>
                      <hf-heading level="" levelStyle="label-small">
                        ${this.category.text}
                      </hf-heading>
                    </div>
                  `
                : nothing}
            </div>
            <div class="article-card__content">
              ${this.articleLength
                ? html`
                    <hf-heading
                      level=""
                      levelStyle="label-small"
                      class="article-card__label-small"
                    >
                      ${this.articleLength}
                    </hf-heading>
                  `
                : nothing}
              <hf-heading
                level="3"
                levelStyle="heading3"
                class="article-card__title"
              >
                ${this.title}
              </hf-heading>
            </div>
          </a>
        </div>
      </div>
    `;
  }
}

customElements.define('hf-article-card', ArticleCard);
